var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Aspect',{attrs:{"type":"insist","span":"7","name":"十四个坚持"}})}
var staticRenderFns = []

export { render, staticRenderFns }